import React from "react"
import StyledLink from "../common/styledLink";
import HtmlContent from "../utils/htmlContent"
import SharpImage from "../utils/sharpImage"
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import EventSummaryStyles from "./eventSummary.styles";

export const EventSummary = ({ event }) => {
    const classes = EventSummaryStyles();

    //TODO: this should be passed in, path is site-specific
    const toPath = "eventers/" + event.slug;
    const featuredImage = event.featuredImage || (event.post && event.post.featuredImage);
    const excerpt = event.excerpt || (event.content && (event.content.excerpt || event.content.rendered)) || event.content;
    return (
        <Card className={classes.eventSummaryContainer} boxShadow={0}>
            <div className={featuredImage ? classes.eventSummarySection : classes.eventSummarySectionNoImg}>
                <div className={classes.eventSummaryTitleMargin}>
                    <Typography variant="h6" className={classes.eventSummaryTitleStyle}>Upcoming Events</Typography>
                    <div className={classes.eventInfo}>
                        <div>{event.title}</div>
                        <div>{event.venue && event.venue.address}</div>
                        <span>{event.dueIn}</span>
                    </div>
                </div>
                <HtmlContent content={excerpt} />
                <StyledLink href={toPath}>View Event</StyledLink>
            </div>
            {featuredImage ?
                <div className={classes.eventSummaryImgSection}>
                    <SharpImage file={featuredImage.node.localFile} title={featuredImage.node.title} altText={featuredImage.node.altText} className={classes.eventSummaryImgContainer} />
                </div>
                : null}
        </Card>
    );
}

export default EventSummary
